// utilities
import { isErrorName } from "../../utilities/requestErrors";

interface UpdatableServiceWorkerRegistration {
  update(): Promise<unknown>;
}

export function startServiceWorkerUpdatePolling(
  registration: UpdatableServiceWorkerRegistration,
  intervalMs: number,
): () => void {
  const stopPolling = () => {
    clearInterval(intervalId);
  };
  const intervalId = setInterval(() => {
    void registration.update().catch((error: unknown) => {
      if (isErrorName(error, "InvalidStateError")) {
        stopPolling();
        return;
      }

      // oxlint-disable-next-line no-console
      console.warn("Service worker update check failed", error);
    });
  }, intervalMs);

  return stopPolling;
}
